import React, { useState, useContext, useRef, useEffect } from "react";
import './Commercial.css';
import Title from "../../ui/title/Title";
import InputField from "../../ui/input-field/InputField";
import Button from "../../ui/button/Button";
import { FormContext } from "../../app/App";

export default function Commercial()
{
    const { show, setShow, showMsg, setShowMsg } = useContext(FormContext);
    const [inputName, setInputName] = useState('');
    const [inputTel, setTel] = useState('');
    const [inputConf, setConf] = useState(false)

    const inputsData = [
        {type: 'text', placeholder: 'Ваше имя', name: 'userName', handler: setInputName, state: inputName},
        {type: 'tel', placeholder: '+7 (___) ___-__-__', name: 'userTel', handler: setTel, state: inputTel}
    ]

    const checkRef = useRef(false);

    useEffect(() => {
        checkRef.current.checked = inputConf
    }, [inputConf])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
          name: inputName,
          tel: inputTel,
          utm: 'airnet_corp_land'
        };
    
        try {
            if(checkRef.current.checked)
            {
                const response = await fetch('/send.php', {
                    method: 'POST',
        
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });
                if (response.ok) {
                    console.log('Data sent successfully!');
                    setShowMsg(!showMsg)
        
                    setTimeout(() => {
                        setShowMsg(false)
                    }, 4000)
                    } else {
                    console.log('Failed to send data.');
                    }
            }  
        } catch (error) {
            console.error('Error:', error);
        }
    };
    
    return (
        <section className="commercial">
            <div className="container">
                <form onSubmit={handleSubmit} method="POST">
                    <Title props={ {type: 'section-title', title: 'Получить коммерческое предложение!'} }/>
                    <p className="commercial-descriprion">Введите свои данные, и мы перезвоним вам</p>
                    <ul className="comercial-form-list">
                        {inputsData.map(input => {
                            return <InputField props={ input }/>
                        })}
                        <div>
                            <Button props={ {disabled: !inputConf, button: 'submit', type: 'section-button', name: 'Оставить заявку'} }/>
                            <div className="confirmWrapper" onClick={() => setConf(!inputConf)}>
                                <input ref={checkRef} name="confirm" className="form-confirm" type="checkbox"></input><span className="confirmText">Даю согласие на обработку персональных данных</span>
                            </div>
                        </div>
                        
                    </ul>
                    
                </form>
            </div>
        </section>
    )
}